import React, { useMemo, useState, useRef } from 'react';

import { Box, Fab, Stack, TextField } from '@mui/material';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import { useAuthContext } from '../../../Context/AuthContext';

import { COLORS } from '../../../Constant/COLORS';
import { ORDER_STATUS } from '../../../Constant/Enums';

import CustomCard from './CustomCard';
import { TypoPoppins } from '../../../Components/Typo';

import useProfessionalOrders from './useProfessionalOrders';
import { dummyOrdersData } from '../../../lib/DummyData/professionalPage';

const JobInformationCompleteSection = () => {
  // const { user } = useAuthContext();

  // const { orders } = useProfessionalOrders(ORDER_STATUS.COMPLETED, user.userID);

  const orders = dummyOrdersData;
  const updateOrders = () => {}; // no-op for dummy

  const [filteredByDate, setFilteredByDate] = useState('');
  const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);

  const scrollableContainer = useRef();

  const filteredJobs = useMemo(() => {
    if (filteredByDate)
      return orders.filter(job => {
        const chosenDate = new Date(filteredByDate).setHours(0, 0, 0, 0).valueOf();
        const jobInfoDate = new Date(job.date).setHours(0, 0, 0, 0).valueOf();
        return jobInfoDate === chosenDate;
      });

    return orders;
  }, [filteredByDate, orders]);

  function handleScrollTopVisibility(event) {
    const shouldScrollTopVisible = event.currentTarget.scrollTop > 100;
    if (shouldScrollTopVisible !== isScrollTopVisible)
      setIsScrollTopVisible(shouldScrollTopVisible);
  }

  function handleScrollTop() {
    scrollableContainer.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <Box
      display='grid'
      mt={2}
      gap={2}
      width='fit-content'
      mx={{ xs: 'auto', md: 'initial' }}
      gridTemplateColumns={{ xs: 'repeat(2,1fr)', md: 'repeat(3,1fr)' }}>
      <TextField
        type='date'
        sx={{ bgcolor: COLORS.white3, gridColumn: '3 / span 1' }}
        onChange={event => setFilteredByDate(event.target.value)}
      />

      <Box gridColumn='span 3' position='relative'>
        <Stack
          gap={3}
          maxHeight={500}
          overflow='auto'
          px={2}
          pb={2}
          onScroll={handleScrollTopVisibility}
          ref={scrollableContainer}
          maxWidth='550px'>
          {filteredJobs.length ? (
            filteredJobs.map(order => (
              <CustomCard key={order.id} data={{ ...order, jobId: order.id }} />
            ))
          ) : (
            <TypoPoppins
              fontWeight={400}
              color='text.secondary'
              variant='h6'
              variantMapping={{ h6: 'p' }}>
              No Completed Jobs Found
            </TypoPoppins>
          )}
        </Stack>

        {isScrollTopVisible && (
          <Fab
            size='small'
            sx={{ position: 'absolute', right: '16px', bottom: '8px' }}
            onClick={handleScrollTop}>
            <ArrowUpwardIcon />
          </Fab>
        )}
      </Box>
    </Box>
  );
};

export default JobInformationCompleteSection;
